import React, { Component } from 'react';
import Layout from '../components/complex/layout';
import LinksSearchBar from './links/linksSearchBar';
import LinksList from './links/linksList';
import RenderUploadLinksForm from './links/uploadLinksForm';
import { Row, Col } from 'react-bootstrap';
import ModalComponent from '../components/complex/modalComponent';
import NewLinkForm from './links/newLinkForm';

class Links extends Component {

  state = {
    keyword: null,
    isActive: false,
    title: null,
    body: null,
  }

  onToggleModal = () => {
    this.setState(prevState => ({ isActive: !prevState.isActive }));
  }

  onLinksListRender = () => {
    this.linksList.onAccept();
  }

  handleShowNewLinkForm = () => {
    const modalProps = {
      onClose: this.onToggleModal,
      onAccept: this.onLinksListRender
    }

    this.setState({ 
      title: 'Add Link',
      body:  <NewLinkForm {...modalProps}  />
    }, () => this.onToggleModal());
  }

  onUpdateSearch = () => {
    this.linksSearchBar.resetKeyWordInput();
  }

  onPreviewDrop = () => {}

  handleShowUploadLinksForm = () => {
    this.setState({
      title: 'Upload',
      body: <RenderUploadLinksForm 
        onToggleModal={this.onToggleModal}
      /> 
    }, () => this.onToggleModal());
  }

  onSearch = (keyword) => {
    this.setState({keyword: keyword});
  }

  render () {
    const {
      isActive,
      title,
      body,
      errorMessage
    } = this.state;

    return (
      <Layout>
        <h1 className="main-title">Links</h1>
        <Row>
          <Col sm={12}>
            <div className="text-right">
              <div
                className="edit-link"
              >
                <span
                  onClick={this.handleShowUploadLinksForm}
                  className="new-link-btn links-upload-button"
                >
                  Upload
                </span>

                <span
                  onClick={this.handleShowNewLinkForm}
                  className="new-link-btn"
                >
                  Add Link
                </span>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <LinksSearchBar 
              onSearch={this.onSearch.bind(this)}
              onRef={ref => (this.linksSearchBar = ref)} 
            />
            <LinksList
              updateSearchBar={this.onUpdateSearch}
              keyword={this.state.keyword}
              onRef={ref => (this.linksList = ref)} 
            />
          </Col>
        </Row>
        <ModalComponent
          isActive={isActive}
          onClose={this.onToggleModal}
          title={title}
          body={body}
          errorMessage={errorMessage}
        />
      </Layout>
    );
  }
}

export default Links;


// WEBPACK FOOTER //
// ./src/app/screens/links.js